import { parseAnyDef } from "./any.js";
export function parseUnknownDef(refs) {
    return parseAnyDef(refs);
}
